// Reajustes registrados na plataforma que ficaram sem aditivo (lote interrompido, Google fora do ar,
// registro sem documento): lista e gera todos de uma vez, um por requisição, como o lote.
import { useState } from "react";
import { FileText } from "lucide-react";
import { postRhGerarAditivo } from "../../api";
import { formatData } from "../estoque/comum";
import { btnStyle } from "../estoque/ui";
import { useFormatValor } from "./valores";

export default function AditivosPendentes({ C, pendentes, onAlterado }) {
  const formatBRL = useFormatValor();
  const [aberto, setAberto] = useState(false);
  const [geracao, setGeracao] = useState(null);
  if (!pendentes?.length && !geracao) return null;

  async function gerar() {
    const estado = { feitos: 0, total: pendentes.length, erros: [] };
    setGeracao({ ...estado });
    for (const p of pendentes) {
      try {
        await postRhGerarAditivo(p.movimentacao_id);
      } catch (e) {
        estado.erros.push(`${p.nome} (${p.numero_aditivo}º aditivo): ${e.message}`);
      }
      estado.feitos += 1;
      setGeracao({ ...estado });
    }
    onAlterado();
  }

  const gerando = geracao && geracao.feitos < geracao.total;
  return (
    <div style={{ background: `${C.warning}18`, border: `1px solid ${C.warning}`, borderRadius: 8, padding: "10px 12px", fontSize: 13, marginBottom: 12 }}>
      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
        <FileText size={16} color={C.warning} style={{ flexShrink: 0 }} />
        <div style={{ flex: 1 }}>
          {geracao && !gerando
            ? <><strong>{geracao.total - geracao.erros.length} aditivo(s) gerado(s).</strong>{geracao.erros.length > 0 && ` ${geracao.erros.length} com erro.`}</>
            : <><strong>{pendentes.length} reajuste(s) sem aditivo.</strong> Registrados na plataforma, mas o documento não foi gerado.</>}
          {!geracao && (
            <button onClick={() => setAberto((v) => !v)} style={{ background: "none", border: "none", color: C.brand, cursor: "pointer", fontFamily: "inherit", fontWeight: 700, marginLeft: 4 }}>
              {aberto ? "Ocultar" : "Ver quais"}
            </button>
          )}
        </div>
        {!geracao && <button onClick={gerar} style={btnStyle(C.brand)}><FileText size={15} /> Gerar aditivos</button>}
      </div>
      {aberto && !geracao && (
        <ul style={{ margin: "6px 0 0", paddingLeft: 24 }}>
          {pendentes.map((p) => (
            <li key={p.movimentacao_id}>{p.nome} — {p.numero_aditivo}º aditivo, {formatBRL(p.valor_mensal)} a partir de {formatData(p.data_vigencia)}</li>
          ))}
        </ul>
      )}
      {gerando && (
        <div style={{ marginTop: 8 }}>
          <div style={{ fontSize: 12, fontWeight: 700 }}>Gerando: {geracao.feitos} de {geracao.total}</div>
          <div style={{ height: 8, background: C.border, borderRadius: 999, marginTop: 4, overflow: "hidden" }}>
            <div style={{ width: `${(100 * geracao.feitos) / geracao.total}%`, height: "100%", background: C.brand, transition: "width 0.3s" }} />
          </div>
        </div>
      )}
      {geracao?.erros.map((e) => <div key={e} style={{ fontSize: 12, color: C.danger, marginTop: 4 }}>{e}</div>)}
    </div>
  );
}
